var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.role === 'screen')?_c('div',{staticClass:"centerContent background"},[_c('video',{staticClass:"video",attrs:{"autoplay":"","src":_vm.video}})]):(_vm.role === 'admin')?_c('div',[_c('next-scene-button')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }